import { useEffect } from 'react';

import { DesireMode } from '@sb/messenger/auto_generated/messenger/arm_control_bot_service';
import type { RoutineRunnerHandle } from '@sbrc/services';
import { getVizbotRoutineRunnerHandle } from '@sbrc/services';
import { useRobotIdentity } from '@sbrc/services/feathers-client/robot-identity';
import { getRobotPosition } from '@sbrc/utils';

import { useDesireMode } from './useDesireMode';
import { useLiveRoutineRunnerHandle } from './useLiveRoutineRunnerHandle';

export function useVizbotRoutineRunnerHandle(): RoutineRunnerHandle {
  const robotIdentity = useRobotIdentity();
  const robotOperationMode = robotIdentity?.robotOperationMode ?? 'live';
  const { desireMode } = useDesireMode();

  const handle = getVizbotRoutineRunnerHandle();

  handle.setDisabled(
    (robotOperationMode === 'assembly' ||
      robotOperationMode === 'calibration') &&
      desireMode !== DesireMode.DESIRE_MODE_LIVE,
  );

  return handle;
}

export const useForceSyncPositionsToVizbot = () => {
  const vizbot = useVizbotRoutineRunnerHandle();
  const liveRunner = useLiveRoutineRunnerHandle();

  useEffect(() => {
    const positions = getRobotPosition(liveRunner)?.jointAngles;

    if (positions) {
      vizbot.vizbotOnlySetJointPositions(positions);
    }
  }, [vizbot, liveRunner]);
};
